import { FetchResult } from '@apollo/client'
import { loader } from 'graphql.macro'
import { client } from 'components/ApolloProvider'
import { Agency } from 'types/agency'
import { DispositionCorrection } from 'types/disposition'
import { GET_DISPOSITIONS } from './getDispositions'
import { CorrectionMutationResponse, GetDispositionsAQR, UpsertCorrectionVariables } from './types'

const dispositionsApi = {
  getDispositions: (payload: {
    agencyId: Agency['id']
    first?: number
    last?: number
  }): Promise<GetDispositionsAQR> =>
    client.query({
      query: GET_DISPOSITIONS,
      variables: {
        agencyId: payload.agencyId,
        first: payload.first ?? null,
        last: payload.last ?? null,
      },
    }),

  upsertCorrection: (
    mutationVariable: UpsertCorrectionVariables
  ): Promise<FetchResult<{ upsertDispositionCorrection: CorrectionMutationResponse }>> =>
    client.mutate({
      mutation: loader('./upsertDispositionCorrection.gql'),
      variables: {
        dispositionId: mutationVariable.dispositionId,
        correctionId: mutationVariable.correctionId ?? null,
        percentChange: mutationVariable.percentChange,
        correctionReason: mutationVariable.correctionReason,
      },
    }),

  sendCorrection: (
    correctionId: DispositionCorrection['id']
  ): Promise<FetchResult<{ sendDispositionCorrection: CorrectionMutationResponse }>> =>
    client.mutate({
      mutation: loader('./sendDispositionCorrection.gql'),
      variables: { correctionId },
    }),
}

export default dispositionsApi
